import PremiumPopover from "components/premium_popover"
import vimeo_manager from "vimeo_manager"
import viewport_helper from "viewport_helper"
import React from "react"

export default ({iframe, timestamps, can_watch_video}) => {
  const links = React.useRef(timestamps.map(() => React.createRef()))
  const [popover_states, set_popover_states] = React.useState(
    Object.fromEntries(timestamps.map((t) => [t.time, false]))
  )

  const on_click = (event, time) => {
    event.preventDefault()
    if (can_watch_video) {
      vimeo_manager.play_video(iframe, time)
      return viewport_helper.go_to(`#${iframe.id}`)
    }
    popover_states[time] = !popover_states[time]
    return set_popover_states({...popover_states})
  }

  return (
    <table>
      <tbody>
        {timestamps.map((timestamp, index) => (
          <tr key={timestamp.time}>
            <td>
              <a
                href={`#${iframe.id}`}
                onClick={(e) => on_click(e, timestamp.time)}
                ref={links.current[index]}>
                {timestamp.time}
              </a>
              {!can_watch_video ? (
                <PremiumPopover
                  target={links.current[index].current}
                  element="video timestamps"
                  placement="right"
                  modifiers={[{
                    name: "flip",
                    options: {fallbackPlacements: ["right", "bottom", "top"]}
                  }]}
                  on_close={() => {
                    popover_states[timestamp.time] = false
                    return set_popover_states({...popover_states})
                  }}
                  is_open={popover_states[timestamp.time]}
                />
              ) : undefined}
            </td>
            <td>{timestamp.title}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
